// import React, { useState, useEffect } from 'react';
// import { Icon } from '@iconify/react';

// const symbolImages = {
//   BTCUSDT: 'https://coin-images.coingecko.com/coins/images/1/large/bitcoin.png?1696501400',
//   SOLUSDT: 'https://assets.coingecko.com/coins/images/4128/large/solana.png?1640133422',
//   ETHUSDT: 'https://assets.coingecko.com/coins/images/279/large/ethereum.png?1595348880',
//   LTCUSDT: 'https://assets.coingecko.com/coins/images/2/large/litecoin.png?1547033580',
//   BCHUSDT: 'https://assets.coingecko.com/coins/images/780/large/bitcoin-cash-circle.png?1594689492',
//   DOGEUSDT: 'https://assets.coingecko.com/coins/images/5/large/dogecoin.png?1547792256',
//   XRPUSDT: 'https://assets.coingecko.com/coins/images/44/large/xrp-symbol-white-128.png?1605778731',
//   BNBUSDT: 'https://cryptologos.cc/logos/binance-coin-bnb-logo.png',
// };

// const UnitCountOne = () => {
//   const [tickers, setTickers] = useState({
//     BTCUSDT: { price: null, change24h: null },
//     SOLUSDT: { price: null, change24h: null },
//     ETHUSDT: { price: null, change24h: null },
//     LTCUSDT: { price: null, change24h: null },
//     BCHUSDT: { price: null, change24h: null },
//     DOGEUSDT: { price: null, change24h: null },
//     XRPUSDT: { price: null, change24h: null },
//     BNBUSDT: { price: null, change24h: null },
//   });

//   useEffect(() => {
//     const ws = new WebSocket('wss://stream.binance.com:9443/ws');

//     const subscription = {
//       method: 'SUBSCRIBE',
//       params: [
//         'btcusdt@ticker',
//         'solusdt@ticker',
//         'ethusdt@ticker',
//         'ltcusdt@ticker',
//         'bchusdt@ticker',
//         'dogeusdt@ticker',
//         'xrpusdt@ticker',
//         'bnbusdt@ticker',
//       ],
//       id: 1,
//     };

//     ws.onopen = () => {
//       ws.send(JSON.stringify(subscription));
//     };

//     ws.onmessage = (event) => {
//       const data = JSON.parse(event.data);

//       if (data.s) {
//         setTickers((prev) => ({
//           ...prev,
//           [data.s]: {
//             price: parseFloat(data.c).toFixed(2),
//             change24h: parseFloat(data.P).toFixed(2),
//           },
//         }));
//       }
//     };

//     return () => ws.close();
//   }, []);

//   return (
    
//     <div className="ticker-container mb-3">
//       <div className="ticker-slider" style={{ overflow: 'hidden', whiteSpace: 'nowrap', padding: '10px' }}>
//         <div className="ticker-marquee" style={{ display: 'inline-block', animation: 'marquee 20s linear infinite' }}>
//           {Object.keys(tickers).map((symbol) => (
//             <div key={symbol} className="ticker-item" style={{ display: 'inline-flex', alignItems: 'center', marginRight: '30px' }}>
//               <div className="d-flex align-items-center gap-3">
//                 <img
//                   src={symbolImages[symbol]}
//                   alt={symbol}
//                   style={{ width: '24px', height: '24px', objectFit: 'contain' }}
//                 />
//                 <p className="mb-0 fw-bold text-primary" style={{ fontSize: '14px', color: '#333' }}>
//                   {symbol.slice(0, 3)}
//                 </p>
//                 <h6 className="mb-0 fw-bold" style={{ fontSize: '16px', color: '#1d72b8' }}>${tickers[symbol].price}</h6>
//                 <span
//                   className={`text-${tickers[symbol].change24h > 0 ? 'success' : 'danger'} d-flex align-items-center gap-1`}
//                   style={{ fontSize: '14px', fontWeight: '500' }}
//                 >
//                   <Icon icon={tickers[symbol].change24h > 0 ? 'bxs:up-arrow' : 'bxs:down-arrow'} className="text-xs" />
//                   {tickers[symbol].change24h}%
//                 </span>
//               </div>
//             </div>
//           ))}
//           {Object.keys(tickers).map((symbol) => (
//             <div key={symbol} className="ticker-item" style={{ display: 'inline-flex', alignItems: 'center', marginRight: '30px' }}>
//               <div className="d-flex align-items-center gap-3">
//                 <img
//                   src={symbolImages[symbol]}
//                   alt={symbol}
//                   style={{ width: '24px', height: '24px', objectFit: 'contain' }}
//                 />
//                 <p className="mb-0 fw-bold text-primary" style={{ fontSize: '14px', color: '#333' }}>
//                   {symbol.slice(0, 3)}
//                 </p>
//                 <h6 className="mb-0 fw-bold" style={{ fontSize: '16px', color: '#1d72b8' }}>${tickers[symbol].price}</h6>
//                 <span
//                   className={`text-${tickers[symbol].change24h > 0 ? 'success' : 'danger'} d-flex align-items-center gap-1`}
//                   style={{ fontSize: '14px', fontWeight: '500' }}
//                 >
//                   <Icon icon={tickers[symbol].change24h > 0 ? 'bxs:up-arrow' : 'bxs:down-arrow'} className="text-xs" />
//                   {tickers[symbol].change24h}%
//                 </span>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>

//   );
// };

// export default UnitCountOne;
import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { Nav, Container, Row, Col, Card, Tab } from "react-bootstrap";

const symbolImages = {
  BTCUSDT: "https://coin-images.coingecko.com/coins/images/1/large/bitcoin.png?1696501400",
  SOLUSDT: "https://assets.coingecko.com/coins/images/4128/large/solana.png?1640133422",
  ETHUSDT: "https://assets.coingecko.com/coins/images/279/large/ethereum.png?1595348880",
  LTCUSDT: "https://assets.coingecko.com/coins/images/2/large/litecoin.png?1547033580",
  BCHUSDT: "https://assets.coingecko.com/coins/images/780/large/bitcoin-cash-circle.png?1594689492",
  DOGEUSDT: "https://assets.coingecko.com/coins/images/5/large/dogecoin.png?1547792256",
  XRPUSDT: "https://assets.coingecko.com/coins/images/44/large/xrp-symbol-white-128.png?1605778731",
  BNBUSDT: "https://cryptologos.cc/logos/binance-coin-bnb-logo.png",
};

const UnitCountOne = () => {
  const [tickers, setTickers] = useState({
    BTCUSDT: { price: null, change24h: null },
    SOLUSDT: { price: null, change24h: null },
    ETHUSDT: { price: null, change24h: null },
    LTCUSDT: { price: null, change24h: null },
    BCHUSDT: { price: null, change24h: null },
    DOGEUSDT: { price: null, change24h: null },
    XRPUSDT: { price: null, change24h: null },
    BNBUSDT: { price: null, change24h: null },
  });

  useEffect(() => {
    const ws = new WebSocket("wss://stream.binance.com:9443/ws");

    const subscription = {
      method: "SUBSCRIBE",
      params: [
        "btcusdt@ticker",
        "solusdt@ticker",
        "ethusdt@ticker",
        "ltcusdt@ticker",
        "bchusdt@ticker",
        "dogeusdt@ticker",
        "xrpusdt@ticker",
        "bnbusdt@ticker",
      ],
      id: 1,
    };

    ws.onopen = () => {
      ws.send(JSON.stringify(subscription));
    };

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);

      if (data.s) {
        setTickers((prev) => ({
          ...prev,
          [data.s]: {
            price: parseFloat(data.c).toFixed(2),
            change24h: parseFloat(data.P).toFixed(2),
          },
        }));
      }
    };

    return () => ws.close();
  }, []);

  return (
    <div className="ticker-container mb-3">
      <div className="ticker-slider">
      {Object.keys(tickers).map((symbol) => (
            <div key={symbol} className="ticker-item" style={{ display: 'inline-flex', alignItems: 'center', marginRight: '30px' }}>
              <div className="d-flex align-items-center gap-3">
                <img
                  src={symbolImages[symbol]}
                  alt={symbol}
                  style={{ width: '24px', height: '24px', objectFit: 'contain' }}
                />
                <p className="mb-0 fw-bold text-primary" style={{ fontSize: '14px', color: '#333' }}>
                  {symbol.slice(0, 3)}
                </p>
                <h6 className="mb-0 fw-bold" style={{ fontSize: '16px', color: '#1d72b8' }}>${tickers[symbol].price}</h6>
                <span
                  className={`text-${tickers[symbol].change24h > 0 ? 'success' : 'danger'} d-flex align-items-center gap-1`}
                  style={{ fontSize: '14px', fontWeight: '500' }}
                >
                  <Icon icon={tickers[symbol].change24h > 0 ? 'bxs:up-arrow' : 'bxs:down-arrow'} className="text-xs" />
                  {tickers[symbol].change24h}%
                </span>
              </div>
            </div>
          ))}
          {Object.keys(tickers).map((symbol) => (
            <div key={symbol} className="ticker-item" style={{ display: 'inline-flex', alignItems: 'center', marginRight: '30px' }}>
              <div className="d-flex align-items-center gap-3">
                <img
                  src={symbolImages[symbol]}
                  alt={symbol}
                  style={{ width: '24px', height: '24px', objectFit: 'contain' }}
                />
                <p className="mb-0 fw-bold text-primary" style={{ fontSize: '14px', color: '#333' }}>
                  {symbol.slice(0, 3)}
                </p>
                <h6 className="mb-0 fw-bold" style={{ fontSize: '16px', color: '#1d72b8' }}>${tickers[symbol].price}</h6>
                <span
                  className={`text-${tickers[symbol].change24h > 0 ? 'success' : 'danger'} d-flex align-items-center gap-1`}
                  style={{ fontSize: '14px', fontWeight: '500' }}
                >
                  <Icon icon={tickers[symbol].change24h > 0 ? 'bxs:up-arrow' : 'bxs:down-arrow'} className="text-xs" />
                  {tickers[symbol].change24h}%
                </span>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default UnitCountOne;


